import { PropTypes } from "prop-types"

import Translate from "../Translate"

const renderLoaderSection = text => {
  return (
    <div
      className="oj-loader-section"
      role="progressbar"
      aria-live="assertive"
      aria-valuetext={text}
      aria-label={text}
    >
      {text && <div className="text">{text}</div>}
      <div className="icon" aria-hidden>
        <span className="loading-circle-1" />
        <span className="loading-circle-2" />
        <span className="loading-circle-3" />
      </div>
    </div>
  )
}

const LoaderSection = ({ textKey, textParams }) => {
  return textKey ? (
    <Translate>{({ translate }) => renderLoaderSection(translate(textKey, textParams))}</Translate>
  ) : (
    renderLoaderSection("")
  )
}

LoaderSection.propTypes = {
  textKey: PropTypes.string,
  textParams: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
}

export default LoaderSection
